<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.procedimentoCirurgico"
                    :request-query-string-params="{ only_procedimentos_cirurgicos: true }"
                    :search-fields="fields.procedimentoCirurgico"
                    :validations="validations.procedimentoCirurgico"
                    label="Procedimento cirúrgico"
                    :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                    uppercase
                    v-model="model.procedimentoCirurgico"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object, formats } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                procedimentoCirurgico: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            procedimentoCirurgico: [
                { key: 'procedimentoCirurgico.procedimentoCodigo', searchable: true },
                { key: 'procedimentoCirurgico.nome', searchable: true },
            ],
        },
        model: {
            procedimentoCirurgico: null,
        },
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.data.model.dataDesejadaProcedimentosCirurgicos.some(p => p.id === this.model.procedimentoCirurgico.id)) {

                        this.showAlert('Procedimento cirúrgico já existente.', 'Atenção')

                        return;
                    }

                    this.data.model.dataDesejadaProcedimentosCirurgicos.push(this.prepareData())

                    this.$emit('save')
                })
        },
        prepareData() {

            return {
                id: this.model.procedimentoCirurgico.id,
                codigo: this.model.procedimentoCirurgico.codigo,
                nome: this.model.procedimentoCirurgico.nome,
            }
        }
    },
    mixins: [repository, object, formats],
    props: {
        data: { type: Object, required: true },
    },
}
</script>